import { useUser } from '@paintscout/ui-business'
import { removeAuth0Prefix } from '@paintscout/util'
import type { CalendarEvent } from 'paintscout'
import { useMemo } from 'react'
import { useClientOptions } from '@paintscout/ui-business'
import { getCrews } from '@paintscout/util'

export const useProductionEventPermissions = (event: CalendarEvent | null | undefined) => {
  const { hasPermissions, user, isOfficeUser, isAdmin, isSuperadmin, isSupport, isCorporate } = useUser()
  const isPrivileged = isAdmin || isSuperadmin || isSupport || isCorporate
  const currentUserId = removeAuth0Prefix(user?.user_id)

  const { options } = useClientOptions()
  const crews = getCrews({ options })
  const crew = crews.find((crew) => crew._id === event?.crew)
  const isProjectManager = removeAuth0Prefix(crew?.projectManager?.id) === currentUserId

  const isOwner = !!event?.estimator?.id && removeAuth0Prefix(event.estimator.id) === currentUserId

  // assigned users are derived from assigned users on the deal + the deal's owner
  const assignedUsers = event?.assignedUsers
  const isAssigned = Array.isArray(assignedUsers)
    ? assignedUsers.some((id) => removeAuth0Prefix(id) === currentUserId)
    : !!assignedUsers &&
      Object.entries(assignedUsers).some(([id, v]) => removeAuth0Prefix(id) === currentUserId && v.assigned)

  const permissionToViewDetails =
    isOfficeUser || isOwner || isAssigned || isPrivileged || isProjectManager || hasPermissions(['read:all-events'])

  const permissionToEdit =
    isOfficeUser || isOwner || isAssigned || isPrivileged || isProjectManager || hasPermissions(['write:all-events'])

  return useMemo(
    () => ({ permissionToViewDetails, permissionToEdit }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [event, user, hasPermissions, isOfficeUser, isPrivileged, isOwner, isAssigned, isProjectManager]
  )
}
